const cmpPodcast = 
{
	component: null,

	init: function (element) 
	{
		const _ = this
		_.component = element

		const ifr = _.component.querySelector('iframe')
		if (ifr)
		{
			const iframeHeight = _.component.getAttribute('data-iframe-height')
			ifr.addEventListener('load', function ()
			{
				window.addEventListener('message', function (message)
				{
					if(message.origin === 'https://podcast.barings.com' ) 
					{
						if(message.data.event) 
						{
							if(message.data.event === 'castedSizeUpdate')
							{ 
								const castedEpisodePlayer = document.getElementById('casted-embed-' + message.data.payload.slug);
								if (castedEpisodePlayer) 
								{
									castedEpisodePlayer.height = message.data.payload.height;
									if(castedEpisodePlayer.contentWindow) 
									{
										castedEpisodePlayer.contentWindow.postMessage({ event: 'castedStopUpdate' }, 'https://podcast.barings.com');
									}
								}
							}
						}
					} else if (iframeHeight) {
						ifr.style.height = iframeHeight + 'px';
					}
				}, false);
			})
		}
	}
}

export default cmpPodcast
